module.exports = __webpack_public_path__ + "static/media/undraw_to_the_moon_v1mv.1e0d118f.svg";